(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-animated-banner"] && !Shopify.designMode) return;
  try {
    

(function () {

  /* =====================================================
     UTILITIES
  ===================================================== */

  function clamp(value, min, max) {

    return Math.max(
      min,
      Math.min(max, value)
    );

  }


  /*
   * Smooth movement.
   *
   * 0 = start
   * 1 = finish
   *
   * Gives soft acceleration + deceleration.
   */

  function smoothStep(value) {

    value = clamp(
      value,
      0,
      1
    );


    return (
      value *
      value *
      (
        3 -
        2 * value
      )
    );

  }



  /* =====================================================
     FIND ACTUAL SCROLLING PARENT
  ===================================================== */

  function getScrollParent(element) {

    var parent =
      element.parentElement;


    while (
      parent &&
      parent !== document.body &&
      parent !== document.documentElement
    ) {

      var styles =
        window.getComputedStyle(
          parent
        );


      var overflowY =
        styles.overflowY;


      if (
        (
          overflowY === 'auto' ||
          overflowY === 'scroll'
        ) &&
        parent.scrollHeight >
        parent.clientHeight
      ) {

        return parent;

      }


      parent =
        parent.parentElement;

    }


    return window;

  }



  /* =====================================================
     INITIALISE SECTION
  ===================================================== */

  function initScrollReveal(section) {

    if (!section) {
      return;
    }


    if (
      section.dataset.scrollRevealReady ===
      'true'
    ) {

      return;

    }


    section.dataset.scrollRevealReady =
      'true';


    var banner1 =
      section.querySelector(
        '[data-reveal-one]'
      );


    var banner2 =
      section.querySelector(
        '[data-reveal-two]'
      );


    if (!banner1) {
      return;
    }



    /* =====================================================
       SHOPIFY TIMING SETTINGS
    ===================================================== */

    var firstEnd =
      parseFloat(
        section.getAttribute(
          'data-overlay-1-exit'
        )
      );


    var secondStart =
      parseFloat(
        section.getAttribute(
          'data-overlay-2-start'
        )
      );


    var secondEnd =
      parseFloat(
        section.getAttribute(
          'data-overlay-2-end'
        )
      );


    if (
      isNaN(firstEnd) ||
      firstEnd <= 0
    ) {

      firstEnd = 0.30;

    }


    if (
      isNaN(secondStart)
    ) {

      secondStart = 0.40;

    }


    if (
      isNaN(secondEnd)
    ) {

      secondEnd = 0.70;

    }


    firstEnd =
      clamp(
        firstEnd,
        0.05,
        0.95
      );


    secondStart =
      clamp(
        secondStart,
        0,
        0.95
      );


    secondEnd =
      clamp(
        secondEnd,
        0.05,
        1
      );


    if (
      secondEnd <= secondStart
    ) {

      secondEnd =
        Math.min(
          secondStart + 0.05,
          1
        );

    }



    /* =====================================================
       SCROLL SOURCE
    ===================================================== */

    var scrollParent =
      getScrollParent(
        section
      );


    var rafPending =
      false;



    /* =====================================================
       GET SECTION SCROLL PROGRESS
    ===================================================== */

    function getProgress() {

      var rect =
        section.getBoundingClientRect();


      var viewportHeight;


      if (
        scrollParent === window
      ) {

        viewportHeight =
          window.innerHeight ||
          document.documentElement.clientHeight;

      } else {

        viewportHeight =
          scrollParent.clientHeight;

      }


      var sectionHeight =
        section.offsetHeight;


      var scrollLength =
        sectionHeight -
        viewportHeight;


      if (
        scrollLength <= 0
      ) {

        return 0;

      }


      var top;


      if (
        scrollParent === window
      ) {

        top =
          rect.top;

      } else {

        var parentRect =
          scrollParent.getBoundingClientRect();


        top =
          rect.top -
          parentRect.top;

      }


      return clamp(
        (-top) /
        scrollLength,
        0,
        1
      );

    }



    /* =====================================================
       BANNER EXIT ANIMATION

       Banner:
       1. moves completely out of screen
       2. fades simultaneously
       3. no clipping / wipe effect
    ===================================================== */

    function setBannerProgress(
      banner,
      progress
    ) {

      if (!banner) {
        return;
      }


      progress =
        clamp(
          progress,
          0,
          1
        );


      /*
       * Smooth scroll progress.
       *
       * Both movement and fade use
       * the SAME progress.
       *
       * Therefore:
       *
       * Move starts = fade starts
       * Move finishes = fade finishes
       */

      var animatedProgress =
        smoothStep(
          progress
        );



      /*
       * MOVE COMPLETELY OUT OF SCREEN
       *
       * -105% means full banner exits
       * through the top.
       *
       * Additional 5% ensures no edge
       * remains visible.
       */

      var moveY =
        -(
          animatedProgress *
          105
        );



      /*
       * FADE SIMULTANEOUSLY
       *
       * Start:
       * progress 0
       * opacity 1
       *
       * Middle:
       * progress 0.5
       * opacity ~0.5
       *
       * End:
       * progress 1
       * opacity 0
       */

      var opacity =
        1 -
        animatedProgress;



      /* ===============================================
         APPLY MOVEMENT
      =============================================== */

      banner.style.setProperty(
        'transform',
        'translate3d(0,' +
          moveY +
          '%,0)',
        'important'
      );



      /* ===============================================
         APPLY FADE
      =============================================== */

      banner.style.setProperty(
        'opacity',
        opacity.toFixed(4),
        'important'
      );



      /* ===============================================
         REMOVE OLD CLIP EFFECT COMPLETELY
      =============================================== */

      banner.style.setProperty(
        'clip-path',
        'none',
        'important'
      );


      banner.style.setProperty(
        '-webkit-clip-path',
        'none',
        'important'
      );



      /* ===============================================
         VISIBILITY

         Hide only AFTER full exit.
         Reverse scrolling makes it
         automatically visible again.
      =============================================== */

      if (
        progress >= 0.999
      ) {

        banner.style.setProperty(
          'visibility',
          'hidden',
          'important'
        );

      } else {

        banner.style.setProperty(
          'visibility',
          'visible',
          'important'
        );

      }

    }



    /* =====================================================
       UPDATE ANIMATION
    ===================================================== */

    function update() {

      rafPending =
        false;


      var progress =
        getProgress();



      /* =================================================
         FIRST BANNER

         Default:
         0% → 30%

         During this full range it:
         moves upward + fades out
      ================================================= */

      var firstProgress =
        progress /
        firstEnd;


      firstProgress =
        clamp(
          firstProgress,
          0,
          1
        );


      setBannerProgress(
        banner1,
        firstProgress
      );



      /* =================================================
         SECOND BANNER

         Default:
         waits until 40%

         40% → 70%
         moves upward + fades out
      ================================================= */

      if (
        banner2
      ) {

        var denominator =
          secondEnd -
          secondStart;


        var secondProgress =
          (
            progress -
            secondStart
          ) /
          denominator;


        secondProgress =
          clamp(
            secondProgress,
            0,
            1
          );


        setBannerProgress(
          banner2,
          secondProgress
        );

      }

    }



    /* =====================================================
       REQUEST FRAME
    ===================================================== */

    function requestUpdate() {

      if (
        rafPending
      ) {

        return;

      }


      rafPending =
        true;


      window.requestAnimationFrame(
        update
      );

    }



    /* =====================================================
       EVENT LISTENERS
    ===================================================== */

    window.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive: true
      }
    );


    if (
      scrollParent !== window
    ) {

      scrollParent.addEventListener(
        'scroll',
        requestUpdate,
        {
          passive: true
        }
      );

    }


    window.addEventListener(
      'resize',
      requestUpdate,
      {
        passive: true
      }
    );


    window.addEventListener(
      'orientationchange',
      requestUpdate,
      {
        passive: true
      }
    );



    /* =====================================================
       INTERSECTION OBSERVER
    ===================================================== */

    var active =
      true;


    if (
      'IntersectionObserver' in window
    ) {

      var observer =
        new IntersectionObserver(

          function (entries) {

            entries.forEach(
              function (entry) {

                active =
                  entry.isIntersecting;


                if (
                  active
                ) {

                  requestUpdate();

                }

              }
            );

          },

          {

            root:
              scrollParent === window
                ? null
                : scrollParent,

            rootMargin:
              '100% 0px 100% 0px',

            threshold:
              0

          }

        );


      observer.observe(
        section
      );

    }



    /* =====================================================
       CONTINUOUS SAFETY LOOP

       Helpful for smooth-scroll Shopify themes.
    ===================================================== */

    function animationLoop() {

      if (
        !document.documentElement.contains(
          section
        )
      ) {

        return;

      }


      if (
        active
      ) {

        update();

      }


      window.requestAnimationFrame(
        animationLoop
      );

    }


    window.requestAnimationFrame(
      animationLoop
    );



    /* =====================================================
       IMAGE LOAD SAFETY
    ===================================================== */

    section
      .querySelectorAll(
        'img'
      )
      .forEach(

        function (image) {

          if (
            !image.complete
          ) {

            image.addEventListener(
              'load',
              requestUpdate,
              {
                once: true
              }
            );

          }

        }

      );



    /* INITIAL POSITION */

    update();

  }



  /* =====================================================
     INIT ALL
  ===================================================== */

  function initAll(root) {

    root =
      root ||
      document;


    if (
      root.matches &&
      root.matches(
        '[data-scroll-reveal]'
      )
    ) {

      initScrollReveal(
        root
      );

    }


    if (
      root.querySelectorAll
    ) {

      root
        .querySelectorAll(
          '[data-scroll-reveal]'
        )
        .forEach(
          initScrollReveal
        );

    }

  }



  /* =====================================================
     PAGE LOAD
  ===================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',

      function () {

        initAll(
          document
        );

      }
    );

  } else {

    initAll(
      document
    );

  }



  /* =====================================================
     SHOPIFY THEME EDITOR
  ===================================================== */

  document.addEventListener(
    'shopify:section:load',

    function (event) {

      var reveal;


      if (
        event.target.matches &&
        event.target.matches(
          '[data-scroll-reveal]'
        )
      ) {

        reveal =
          event.target;

      } else {

        reveal =
          event.target.querySelector(
            '[data-scroll-reveal]'
          );

      }


      if (
        reveal
      ) {

        reveal.dataset.scrollRevealReady =
          'false';


        initScrollReveal(
          reveal
        );

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    

  (function () {

    class HeroCarousel {

      constructor(el) {

        this.el = el;

        this.slides = Array.from(el.querySelectorAll('[data-slide]'));

        this.segs = Array.from(el.querySelectorAll('.hero-carousel__nav-seg'));

        this.prevBtn = el.querySelector('.hero-carousel__arrow--prev');

        this.nextBtn = el.querySelector('.hero-carousel__arrow--next');

        this.current = 0;

        this.autoplay = el.dataset.autoplay === 'true';

        this.speed = parseInt(el.dataset.autoplaySpeed, 10) || 4500;

        this.timer = null;



        this.bind();

        this.updateRatio();

        if (this.autoplay && this.slides.length > 1) this.play();

      }



      bind() {

        this.segs.forEach((seg, i) => seg.addEventListener('click', () => this.goTo(i)));

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.current - 1));

        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.current + 1));

        this.el.addEventListener('mouseenter', () => this.pause());

        this.el.addEventListener('mouseleave', () => { if (this.autoplay) this.play(); });

      }



      goTo(index) {

        const total = this.slides.length;

        if (total === 0) return;

        this.current = (index + total) % total;



        this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.current));



        this.segs.forEach((seg, i) => {

          seg.classList.toggle('is-active', i === this.current);

          const fill = seg.querySelector('.hero-carousel__nav-fill');

          if (!fill) return;

          fill.style.animation = 'none';

          if (i === this.current) {

            requestAnimationFrame(() => {

              fill.style.animation = `heroCarouselFill ${this.speed}ms linear forwards`;

            });

          } else {

            fill.style.width = '0%';

          }

        });



        this.updateRatio();

        if (this.autoplay) this.play();

      }



      updateRatio() {

        const slide = this.slides[this.current];

        if (!slide) return;

        this.el.style.setProperty('--hero-carousel-ratio-desktop', slide.dataset.ratioDesktop || '1.78');

        this.el.style.setProperty('--hero-carousel-ratio-mobile', slide.dataset.ratioMobile || '0.8');

      }



      play() {

        clearTimeout(this.timer);

        if (this.slides.length < 2) return;

        this.timer = setTimeout(() => this.goTo(this.current + 1), this.speed);

      }



      pause() {

        clearTimeout(this.timer);

      }

    }



    function init() {

      document.querySelectorAll('[data-hero-carousel]').forEach((el) => {

        if (el.heroCarouselInstance) return;

        el.heroCarouselInstance = new HeroCarousel(el);

      });

    }



    if (document.readyState === 'loading') {

      document.addEventListener('DOMContentLoaded', init);

    } else {

      init();

    }



    document.addEventListener('shopify:section:load', init);

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Mobile: start with the link lists folded; desktop always shows them.
    const sync = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      document.querySelectorAll('.mwf__col').forEach((col) => {
        if (mobile && !col.dataset.touched) col.open = false;
        if (!mobile) col.open = true;
      });
    };
    document.addEventListener('click', (e) => {
      const summary = e.target instanceof Element && e.target.closest('.mwf__heading');
      if (summary) summary.parentElement.dataset.touched = 'true';
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
    window.matchMedia('(max-width: 749px)').addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (!root || root.dataset.mwReady) return;
      root.dataset.mwReady = 'true';

      const activeTrack = () => root.querySelector('[data-mw-panel]:not([hidden]) [data-mw-track]');

      const step = (direction) => {
        const track = activeTrack();
        if (!track) return;
        const item = track.querySelector('.mw-carousel__item');
        const gap = parseFloat(getComputedStyle(track).columnGap || '0');
        const amount = item ? (item.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(track.clientWidth / (item.getBoundingClientRect().width + gap))) : track.clientWidth;
        const max = track.scrollWidth - track.clientWidth;
        if (direction > 0 && track.scrollLeft >= max - 2) track.scrollTo({ left: 0 });
        else if (direction < 0 && track.scrollLeft <= 2) track.scrollTo({ left: max });
        else track.scrollBy({ left: amount * direction });
      };

      root.querySelector('[data-mw-prev]')?.addEventListener('click', () => step(-1));
      root.querySelector('[data-mw-next]')?.addEventListener('click', () => step(1));

      const viewAll = root.querySelector('[data-mw-view-all]');
      root.querySelectorAll('[data-mw-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const id = tab.dataset.mwTab;
          root.querySelectorAll('[data-mw-tab]').forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          root.querySelectorAll('[data-mw-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.mwPanel !== id;
          });
          if (viewAll && tab.dataset.viewAll) viewAll.href = tab.dataset.viewAll;
        });
      });
    };

    const init = () => document.querySelectorAll('[data-mw-carousel]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';

      // Only this section's own tabs: the Judge.me widget inside has tabs of its own.
      const tabs = [...root.querySelectorAll('.mwpt__tabs > [role="tab"]')];
      const panels = [...root.querySelectorAll('.mwpt__inner > [data-panel]')];
      if (!tabs.length) return;

      const activate = (name, { focus = false, scroll = false } = {}) => {
        const tab = tabs.find((t) => t.dataset.tab === name) || tabs[0];
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach((p) => (p.hidden = p.dataset.panel !== tab.dataset.tab));
        if (focus) tab.focus();
        if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (tab.dataset.tab === 'overview') clampOverview();
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab.dataset.tab));
        tab.addEventListener('keydown', (e) => {
          let next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            e.preventDefault();
            activate(next.dataset.tab, { focus: true });
          }
        });
      });

      // Long descriptions: show the first part with a "Read more" button.
      const overview = root.querySelector('[data-overview]');
      const toggle = root.querySelector('[data-overview-toggle]');
      let clampChecked = false;
      const clampOverview = () => {
        if (!overview || !toggle || clampChecked || overview.offsetParent === null) return;
        clampChecked = true;
        if (overview.scrollHeight > 420) {
          overview.classList.add('is-clamped');
          toggle.hidden = false;
        }
      };
      toggle?.addEventListener('click', () => {
        const open = overview.classList.toggle('is-clamped') === false;
        toggle.querySelector('[data-more]').hidden = open;
        toggle.querySelector('[data-less]').hidden = !open;
        if (!open) overview.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Deep links (#overview, #specifications, #reviews) and Judge.me star badge clicks.
      const fromHash = () => {
        const hash = location.hash.replace('#', '');
        if (tabs.some((t) => t.dataset.tab === hash)) activate(hash, { scroll: true });
        else if (hash === 'judgeme_product_reviews') activate('reviews', { scroll: true });
      };

      document.addEventListener(
        'click',
        (e) => {
          const t = e.target instanceof Element ? e.target : null;
          if (!t || root.contains(t)) return;
          if (t.closest('.jdgm-preview-badge, .jdgm-widget.jdgm-preview-badge, a[href$="#judgeme_product_reviews"], a[href$="#reviews"]')) {
            e.preventDefault();
            activate('reviews', { scroll: true });
          }
        },
        true
      );

      activate(tabs[0].dataset.tab);
      fromHash();
      window.addEventListener('hashchange', fromHash);
    };

    const init = () => document.querySelectorAll('[data-mw-tabs]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
